import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import '@/styles/tokens.css';
import '@/styles/base.css';
import '@/styles/layout.css';
import '@/styles/componentes.css';
import '@/styles/controles.css';
import '@/styles/listas.css';
import '@/styles/mapa.css';
import '@/styles/exploracao.css';
const raiz = document.getElementById('raiz');
if (raiz === null) {
    throw new Error('elemento raiz da aplicação não encontrado');
}
createRoot(raiz).render(_jsx(StrictMode, { children: _jsx(App, {}) }));
